<template>
  <div class="invoiceNotice-container">
    <div class="info-top-panel">
      <h2>注意事项：</h2>
      <p>
        1、请严格按照主体信息和对应金额进行开票。<br />
        2、发票邮寄只接受寄付，到付快递会直接退回。<br />
        3、发票上的价税合计项金额须与待核销金额一致。<br />
        4、只收“专票”，如开具“普票”无法核销账单及付款。
      </p>
    </div>
    <div
      v-if="!agentName && !loading"
      class="info-main-panel"
    >
      <div
        v-for="(invoice, index) in invoiceList"
        :key="index"
      >
        <div class="top-tip">
          <div class="left">
            {{ invoice.contractBody }}
          </div>
          <div
            class="right"
            @click="goToInvoiceBillPage(invoice)"
          >
            <span>待核销：{{ invoice.settleAmount }} </span>
            <img
              class="icon-arrow"
              src="@/assets/img/arrow-right@2x.png"
            />
          </div>
        </div>
        <div class="info-panel">
          <div class="row">
            <div class="left">
              开户银行
            </div>
            <div class="right">
              {{ invoice.bankName }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              企业名称
            </div>
            <div class="right">
              {{ invoice.companyName }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              银行账号
            </div>
            <div class="right">
              {{ invoice.bankAccountId }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              纳税人识别号
            </div>
            <div class="right">
              {{ invoice.taxIdNo }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              地址
            </div>
            <div class="right">
              {{ invoice.address }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              电话
            </div>
            <div class="right">
              {{ invoice.phone }}
            </div>
          </div>
          <div class="single-row">
            <van-button
              type="primary"
              size="small"
              plain
              hairline
              class="copy-btn"
              @click="copyInvoiceText(invoice)"
            >
              <div class="btn-icon-outer">
                <img
                  class="btn-copy-icon"
                  src="@/assets/img/copy-icon@2x.png"
                />
                一键复制
              </div>
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!agentName && !loading"
      class="info-main-panel"
    >
      <div class="top-tip">
        开票项目须从以下内容选择其一
      </div>
      <div class="info-panel">
        {{ invoiceTypes.join('；') }}
      </div>
    </div>
    <div
      v-if="!agentName && !loading"
      class="info-main-panel"
    >
      <div class="top-tip">
        美团收票地址
      </div>
      <div class="info-panel">
        <div>
          <div class="title">
            纸质发票：
          </div>
          <div class="row">
            <div class="left">
              收件人
            </div>
            <div class="right">
              {{ paperInvoice.receiver }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              电话
            </div>
            <div class="right">
              {{ paperInvoice.phone }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              地址
            </div>
            <div class="right">
              {{ paperInvoice.address }}
            </div>
          </div>
          <div class="single-row">
            <van-button
              type="primary"
              size="small"
              plain
              hairline
              class="copy-btn"
              @click="copyAddressText"
            >
              <div class="btn-icon-outer">
                <img
                  class="btn-copy-icon"
                  src="@/assets/img/copy-icon@2x.png"
                />
                一键复制
              </div>
            </van-button>
          </div>
        </div>
        <div class="info-gap">
          <div class="title">
            电子发票：
          </div>
          <div class="row">
            <div class="left">
              邮箱
            </div>
            <div class="right">
              {{ electricInvoice.email }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              标题格式
            </div>
            <div class="right">
              {{ electricInvoice.title }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              正文内容
            </div>
            <div class="right">
              {{ electricInvoice.textContent }}
            </div>
          </div>
          <div class="row">
            <div class="left">
              附件内容
            </div>
            <div class="right">
              {{ electricInvoice.attachContent }}
            </div>
          </div>
          <div class="single-row">
            <van-button
              type="primary"
              size="small"
              plain
              hairline
              class="copy-btn"
              @click="copyEmail"
            >
              <div class="btn-icon-outer">
                <img
                  class="btn-copy-icon"
                  src="@/assets/img/copy-icon@2x.png"
                />
                复制邮箱地址
              </div>
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!agentName && !loading"
      class="info-main-panel"
    >
      <div class="top-tip">
        合同详情
      </div>
      <long-list
        class="info-panel"
        :api-method="getContractDetails"
      >
        <template #default="{list}">
          <div
            v-for="(constract, index) in list"
            :key="index"
            class="row"
          >
            <div class="left">
              {{ constract.desc }}
            </div>
            <div
              v-if="!$isWXApplet"
              class="right preview"
              @click="privewCoop(constract.url)"
            >
              点击预览
              <img
                class="icon-arrow"
                src="@/assets/img/arrow-right@2x.png"
              />
            </div>
          </div>
        </template>
      </long-list>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import VueClipboard from 'vue-clipboard2';
import Contract from '@/api/contract';
import STATUS from '@/constants/status';
import LongList from '@/components/LongList';
import tracker from '@/util/tracker';

Vue.use(VueClipboard);
export default {
  name: 'Cooperation',
  components: {
    LongList,
  },
  data() {
    return {
      agentName: '',
      loading: true,
      paperInvoice: {},
      electricInvoice: {},
      getContractDetails: Contract.getContractDetails,
      cid: this.$BID.InvoiceNotice,
      invoiceTypes: [],
    };
  },
  computed: {
    ...mapState(['currentPoi', 'poiList']),
    ...mapState('invoiceModule', ['invoiceList']),
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('invoiceModule', ['getInvoiceList']),
    async init() {
      this.$store.commit('setLoading', true);
      const { poiId, poiStatus, poiSource } = this.currentPoi;
      const poiLen = this.poiList.length;
      const pId = poiLen > 1 ? this.poiList[1].poiId : poiId;
      Promise.all([this.getData(pId, poiStatus, poiSource), this.getInvoiceList(), this.getInvoiceReceiver(), this.getInvoiceTypes()]).then(() => {
        this.$store.commit('setLoading', false);
        this.loading = false;
        for (let i = 0; i < this.invoiceList.length; i++) {
          const invoice = this.invoiceList[i];
          tracker.sendModuleView(this.$BID.INVOICE_COPY_CONTRACT_MV, { contract_body: invoice.contractBody }, { cid: this.cid });
        }
      });
    },
    async getInvoiceReceiver() {
      const res = await Contract.getInvoiceReceiver();
      if (res.respCode === STATUS.SUCCESS && res.data) {
        this.paperInvoice = res.data.paperInvoice || {};
        this.electricInvoice = res.data.electricInvoice || {};
      }
    },
    generateInvoiceText(invoice) {
      const template = `开户银行：${invoice.bankName}
      企业名称：${invoice.companyName}
      银行账号：${invoice.bankAccountId}
      纳税人识别号：${invoice.taxIdNo}
      地址：${invoice.address}
      电话：${invoice.phone}
      `;
      return template.replace(/^\s+/gm, '');
    },
    copyInvoiceText(invoice) {
      tracker.sendModuleClick(this.$BID.INVOICE_COPY_CONTRACT_MC, { contract_body: invoice.contractBody }, { cid: this.cid });
      const invoiceText = this.generateInvoiceText(invoice);
      this.$copyText(invoiceText).then(() => {
        this.$dialog.toast('复制发票抬头成功');
      }, () => {
        this.$dialog.toast('复制发票抬头失败，请手动选择文案复制');
      });
    },
    async getData(poiId) {
      const res = await Contract.getPoiDetail(poiId);
      if (res.respCode === STATUS.SUCCESS && res.data) {
        const contract = res.data[0] || {};
        this.agentName = contract.agentName;
      }
    },
    copyAddressText() {
      tracker.sendModuleClick(this.$BID.INVOICE_COPY_ADDRESS, null, { cid: this.cid });
      const { receiver, phone, address } = this.paperInvoice;
      const addressText = `收件人：${receiver}
        电话：${phone}
        地址：${address}`;
      this.$copyText(addressText.replace(/^\s+/gm, '')).then(() => {
        this.$dialog.toast('复制收票地址成功');
      }, () => {
        this.$dialog.toast('复制收票地址失败，请手动选择文案复制');
      });
    },
    copyEmail() {
      tracker.sendModuleClick(this.$BID.INVOICE_COPY_EMAIL, null, { cid: this.cid });
      const { email } = this.electricInvoice;
      this.$copyText(email).then(() => {
        this.$dialog.toast('复制邮箱地址成功');
      }, () => {
        this.$dialog.toast('复制邮箱地址失败，请手动选择文案复制');
      });
    },
    goToInvoiceBillPage(invoice) {
      tracker.sendModuleClick(this.$BID.INVOICE_WRITEOFF_AMOUNT, { contract_body: invoice.contractBody }, { cid: this.cid });
      this.$router.push({ name: 'InvoiceBill', params: { contractBody: invoice.contractBody } });
    },
    privewCoop(pdfUrl) {
      this.$router.push({ name: 'contractPdf', params: { pdfUrl } });
    },
    async getInvoiceTypes() {
      const data = await this.$horn.fetch('invoice_type', {}, { types: [] });
      this.invoiceTypes = data.types || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.invoiceNotice-container {
  padding-bottom: 170px;
  text-align: left;
  .info-top-panel {
    line-height: 37px;
    padding: 12px 28px 36px 36px;
    font-size: 26px;
    background: #FFF;
    h2 {
      color: rgba(0, 0, 0, .84);
      height: 37px;
      font-weight: bold;
    }
    p {
      margin-top: 12px;
      color: rgba(0, 0, 0, .42);
      letter-spacing: 0;
    }
  }
  .icon-arrow {
    width: 24px;
    height: 24px;
    margin-left: 6px;
  }
  .top-tip {
    display: flex;
    padding: 15px 0 8px;
    margin: 6px 18px;
    font-size: 26px;
    font-weight: bold;
    color: #000000;
    opacity: 0.6;
    border-bottom: 1px solid rgba(0, 0, 0, .06);
    .right {
      flex: 1;
      opacity: 0.9;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
  .info-panel {
    margin: 12px 18px 0;
    padding: 30px 36px;
    border-radius: 12px;
    background: #FFF;

    .info-gap {
      margin-top: 50px;
    }
    .title {
      margin-left: -15px;
      line-height: 45px;
      font-size: 26px;
      font-weight: bold;
      text-align: left;
      color: rgba(0, 0, 0, .84);
      letter-spacing: 0;
    }
    .single-row {
      padding-top: 24px;
      font-size: 26px;
      color: rgba(0, 0, 0, .6);
    }
    .row {
      display: flex;
      margin-top: 24px;
      line-height: 37px;
      font-size: 26px;
      &:first-child {
        margin-top: 0;
      }
      .left {
        margin-right: 18px;
        color: rgba(0, 0, 0, .42);
      }
      .right {
        flex: 1;
        color: rgba(0, 0, 0, .84);
        text-align: right;
      }
      .preview {
          color: #0A70F5;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
    }
  }
  .copy-btn {
    width: 100%;
    color: rgba(0, 0, 0, .84);
    position: relative;
    border: 0;
    &::after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 200%;
      height: 200%;
      transform: scale(0.5);
      transform-origin: left top;
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, .5);
      border-radius: 4px;
      pointer-events: none;
    }
  }
  .btn-icon-outer {
    display: inline-block;
    position: relative;
  }
  .btn-copy-icon {
    position: absolute;
    width: 30px;
    height: 30px;
    left: -42px;
    top: 50%;
    margin-top: -15px;
  }
}
</style>
